/* This file was created automatically, don't change it manually. */

import React, { forwardRef } from 'react';

import { ColorlessIconProps } from '../../types';
import { SVGContainer } from '../../SVGContainer';

const IconUser8 = forwardRef<SVGSVGElement, ColorlessIconProps>(function IconUser8(props, ref) {
    return (
        <SVGContainer {...props} viewBox="0 0 8 8" ref={ref}>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M1.672 6.217c.075.052.209.122.417.191.458.153 1.134.259 1.911.259.777 0 1.453-.106 1.91-.259.21-.07.343-.139.418-.191a.7.7 0 0 0-.09-.296.755.755 0 0 0-.306-.272c-.35-.19-.963-.316-1.932-.316s-1.582.126-1.932.316a.755.755 0 0 0-.307.272.7.7 0 0 0-.089.296ZM1 6.333c0-1.166 1.001-1.666 3-1.666s3 .5 3 1.666c0 .554-1.343 1-3 1-1.658 0-3-.446-3-1ZM4 3.668c.396 0 1-.428 1-1.333 0-.482-.173-.755-.356-.915A1.028 1.028 0 0 0 4 1.168c-.184 0-.442.074-.644.252-.183.16-.356.433-.356.915 0 .905.604 1.333 1 1.333Zm1.667-1.333c0 1.2-.834 2-1.667 2-.833 0-1.667-.8-1.667-2C2.333 1 3.333.5 4 .5s1.667.5 1.667 1.834Z"
                fill="currentColor"
            />
        </SVGContainer>
    );
});

const IconUser12 = forwardRef<SVGSVGElement, ColorlessIconProps>(function IconUser12(props, ref) {
    return (
        <SVGContainer {...props} viewBox="0 0 12 12" ref={ref}>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M2.508 9.325c.112.079.313.183.626.287.687.23 1.7.388 2.866.388 1.166 0 2.18-.159 2.866-.388a2.51 2.51 0 0 0 .626-.287 1.051 1.051 0 0 0-.134-.444c-.08-.135-.216-.276-.46-.408C8.372 8.188 7.453 8 6 8s-2.372.188-2.898.473c-.244.132-.38.273-.46.408a1.051 1.051 0 0 0-.134.444ZM1.5 9.5C1.5 7.75 3.002 7 6 7s4.5.75 4.5 2.5c0 .83-2.014 1.5-4.5 1.5s-4.5-.67-4.5-1.5ZM6 5.502c.594 0 1.5-.643 1.5-2 0-.723-.259-1.132-.534-1.372A1.543 1.543 0 0 0 6 1.752c-.276 0-.662.111-.966.378-.275.24-.534.649-.534 1.372 0 1.357.906 2 1.5 2Zm2.5-2c0 1.8-1.25 3-2.5 3s-2.5-1.2-2.5-3c0-2 1.5-2.75 2.5-2.75s2.5.75 2.5 2.75Z"
                fill="currentColor"
            />
        </SVGContainer>
    );
});

const IconUser16 = forwardRef<SVGSVGElement, ColorlessIconProps>(function IconUser16(props, ref) {
    return (
        <SVGContainer {...props} viewBox="0 0 16 16" ref={ref}>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M3.344 12.434c.15.104.417.243.834.382.917.305 2.268.517 3.822.517 1.554 0 2.905-.212 3.822-.517.417-.139.685-.278.834-.383a1.402 1.402 0 0 0-.178-.592c-.107-.18-.288-.368-.614-.544-.7-.38-1.926-.63-3.864-.63s-3.163.25-3.864.63c-.326.176-.507.364-.614.544-.084.142-.152.33-.178.593ZM2 12.665c0-2.333 2.003-3.333 6-3.333 3.998 0 6 1 6 3.333 0 1.107-2.685 2-6 2s-6-.893-6-2ZM8 7.336c.792 0 2-.857 2-2.667 0-.964-.345-1.51-.711-1.83A2.057 2.057 0 0 0 8 2.336c-.369 0-.883.148-1.289.503C6.345 3.16 6 3.705 6 4.67c0 1.81 1.208 2.667 2 2.667Zm3.333-2.667c0 2.4-1.666 4-3.333 4-1.667 0-3.333-1.6-3.333-4 0-2.667 2-3.667 3.333-3.667 1.333 0 3.333 1 3.333 3.667Z"
                fill="currentColor"
            />
        </SVGContainer>
    );
});

const IconUser20 = forwardRef<SVGSVGElement, ColorlessIconProps>(function IconUser20(props, ref) {
    return (
        <SVGContainer {...props} viewBox="0 0 20 20" ref={ref}>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M4.18 15.542c.187.131.522.305 1.043.479 1.145.381 2.834.645 4.777.645s3.632-.264 4.777-.645c.521-.174.856-.348 1.043-.479a1.753 1.753 0 0 0-.223-.74c-.133-.226-.36-.46-.767-.68-.876-.475-2.408-.789-4.83-.789s-3.954.314-4.83.789c-.407.22-.633.454-.767.68-.106.177-.191.413-.223.74Zm-1.68.291c0-2.917 2.503-4.167 7.5-4.167s7.5 1.25 7.5 4.167c0 1.383-3.356 2.5-7.5 2.5s-7.5-1.117-7.5-2.5ZM10 9.17c.99 0 2.5-1.071 2.5-3.333 0-1.205-.432-1.887-.89-2.288-.506-.443-1.15-.629-1.61-.629-.46 0-1.104.186-1.61.63-.458.4-.89 1.082-.89 2.287C7.5 8.099 9.01 9.17 10 9.17Zm4.167-3.333c0 3-2.084 5-4.167 5-2.083 0-4.167-2-4.167-5 0-3.334 2.5-4.584 4.167-4.584 1.667 0 4.167 1.25 4.167 4.584Z"
                fill="currentColor"
            />
        </SVGContainer>
    );
});

const IconUser24 = forwardRef<SVGSVGElement, ColorlessIconProps>(function IconUser24(props, ref) {
    return (
        <SVGContainer {...props} viewBox="0 0 24 24" ref={ref}>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M5.016 18.65c.224.158.626.366 1.251.575 1.375.457 3.401.774 5.733.774s4.358-.317 5.733-.774c.625-.209 1.027-.417 1.25-.575-.037-.393-.14-.675-.266-.888-.16-.27-.432-.552-.92-.816-1.052-.57-2.89-.947-5.797-.947-2.907 0-4.745.377-5.796.947-.489.264-.76.545-.92.816-.127.213-.23.495-.268.889ZM3 19c0-3.5 3.004-5 9-5s9 1.5 9 5c0 1.66-4.027 3-9 3s-9-1.34-9-3ZM12 11.004c1.188 0 3-1.285 3-4 0-1.446-.518-2.265-1.067-2.745-.608-.532-1.38-.755-1.933-.755-.553 0-1.325.223-1.933.755C9.518 4.74 9 5.558 9 7.004c0 2.714 1.812 4 3 4Zm5-4c0 3.6-2.5 6-5 6s-5-2.4-5-6c0-4 3-5.5 5-5.5s5 1.5 5 5.5Z"
                fill="currentColor"
            />
        </SVGContainer>
    );
});

export const IconUser = forwardRef<SVGSVGElement, ColorlessIconProps>(function IconUser(props, ref) {
    const { size = '16', role = 'supplementary' } = props;

    const iconProps = {
        ...props,
        size,
        ref,
        role,
        colorless: true,
    } as const;

    switch (size) {
        case '8':
            return <IconUser8 {...iconProps} />;
        case '12':
            return <IconUser12 {...iconProps} />;
        case '16':
            return <IconUser16 {...iconProps} />;
        case '20':
            return <IconUser20 {...iconProps} />;
        case '24':
            return <IconUser24 {...iconProps} />;
        default:
            return <IconUser24 {...iconProps} />;
    }
});
